export const setCaretPosition = (ctrl, pos) => {
  // Modern browsers
  if (ctrl.setSelectionRange) {
    ctrl.setSelectionRange(pos, pos)
  } else if (ctrl.createTextRange) {
    // IE8 and below
    const range = ctrl.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }
}

export const checkIfFileExceedsSizeLimit = (file, sizeInMb) => {
  const maxSize = sizeInMb * 1024 * 1024
  return file && file.size > maxSize
}

export const bytesToMB = bytes => {
  return (bytes / (1024 * 1024)).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/components/Form/utils.js